import { render, staticRenderFns } from "./teamPage.vue?vue&type=template&id=fc20be98&scoped=true"
import script from "./teamPage.vue?vue&type=script&lang=js"
export * from "./teamPage.vue?vue&type=script&lang=js"
import style0 from "./teamPage.vue?vue&type=style&index=0&id=fc20be98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc20be98",
  null
  
)

export default component.exports